// extracted by mini-css-extract-plugin
module.exports = {"container":"inputTag_container__3DnYy","container__errored":"inputTag_container__errored__2ZNQ3","ico":"inputTag_ico__1zY1G","tag":"inputTag_tag__RZLP0"};